<template>
  <div>
    <div class="pa-4 d-flex justify-space-between align-center">
      <div>
        <Breadcrumbs
          headline="Khen thưởng kỷ luật"
          :link="[
            { text: 'Học sinh', href: '../students' },
            { text: 'KTKL', href: '/complimented' }
          ]"
        />
      </div>
      <div class="flex-center">
        <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
          <v-icon left>mdi-file-excel</v-icon> Xuất Excel
        </v-btn>
        <v-btn class="ml-6" v-if="$auth.policies['add-new-violation']" color="primary" @click="dialog = !dialog">
          <v-icon left>add</v-icon> {{ btnTitle }}
        </v-btn>
      </div>
    </div>
    <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
      <ViolationFilter @onFilterChanged="refresh" :defaultStudentId="defaultStudentId" />
    </v-card>

    <v-card outlined class="mx-4 elevation-0">
      <ViolationDataTable ref="violationDataTable" />
    </v-card>
    <AddViolationDialog :state="dialog" @done="done" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import utils from '@/plugins/utils'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import ViolationFilter from './components/ViolationFilter.vue'
import AddViolationDialog from './components/AddViolationDialog.vue'
import ViolationDataTable from './components/ViolationDataTable.vue'

export default {
  components: {
    Breadcrumbs,
    ViolationFilter,
    AddViolationDialog,
    ViolationDataTable
  },
  data() {
    return {
      createState: false,
      filterState: false,
      dialog: false,
      sendState: false,
      defaultStudentId: ''
    }
  },
  computed: {
    ...mapState('violation', ['violations', 'searchParams']),
    ...mapState('app', ['currentSemester']),

    btnTitle() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'Thêm'
      } else {
        return 'Thêm KTKL'
      }
    }
  },
  created() {},
  mounted() {
    let param = {}
    if (this.$route.query.student) {
      param.student = this.$route.query.student
      this.defaultStudentId = this.$route.query.student
    }
    this.refresh(param)
  },
  methods: {
    ...mapActions('violation', ['fetchViolations']),
    updateDraw(draw) {
      this.draw = draw
    },
    refresh(query) {
      this.$refs.violationDataTable.refresh(query)
    },
    done() {
      if (this.violations && this.violations.length === 1) {
        this.refresh()
      }
    },
    async exportExcel() {
      try {
        this.$loading.active = true
        let headers = [...this.$refs.violationDataTable.originHeaders]
        headers.splice(-1)
        headers.splice(3, 0, {
          text: 'Mã số',
          value: 'code'
        })
        const excelHeader = headers.map(({ text, value }) => ({ text, value }))
        const filters = this.$options.filters

        const list = await this.fetchViolations({ ...this.searchParams, _limit: -1 })
        const data = list.map(item => {
          item.class = item.class && item.class.title
          item.code = filters.getStudentCode((item.student && item.student.code) || '')
          item.student = item.student && item.student.name
          item.date = filters.ddmmyyyy(item.date)
          item.type = item.type === 'violation' ? 'Kỷ luật' : item.type === 'commendation' ? 'Khen thưởng' : ''
          return item
        })

        utils.exportExcel(data, excelHeader, 'KhenThuongKyLuat')
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
